import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import LoggedAction from 'src/app/model/logged-action';
import { ImmoIPImmoTaskChangesObject } from '../../immo-ip-placer-offline-changes/immo-ip-immo-task-changes/immo-ip-immo-task-changes-object';
import { LoadingService } from '../../loading.service';
import { SnackService } from '../../snack.service';
import { Observable } from 'rxjs';
import { _post, DeserializeVoid } from '../../base.service';

@Injectable({
  providedIn: 'root',
})
export class TourInstallerSubmitImmoTaskControllerRequestService {
  private static BASE_URL = '/tourInstaller';

  private readonly post: <T>(
    path: string,
    body: SubmitRequestBody | ModifyFeedbackRequestBody,
    deserialize: (response: any) => T
  ) => Observable<T>;
  private readonly deserialize = (res) => res as SubmitResponse;

  constructor(
    http: HttpClient,
    snackService: SnackService,
    loadingService: LoadingService,
    router: Router
  ) {
    const requestServices = {
      http,
      loadingService,
      router,
      snackService,
    };
    this.post = _post(
      TourInstallerSubmitImmoTaskControllerRequestService.BASE_URL,
      requestServices
    );
  }

  public submitImmoTask(
    immoTaskChanges: ImmoIPImmoTaskChangesObject
  ): Promise<SubmitResponse> {
    const requestBody: SubmitRequestBody = {
      id: immoTaskChanges.id,
      executionFeedback: immoTaskChanges.executionFeedback,
      executed: immoTaskChanges.executed,
      executedDate:
        immoTaskChanges.executedRegistration == null
          ? null
          : immoTaskChanges.executedRegistration.date,
    };
    return this.post(
      '/submitImmoTask',
      requestBody,
      this.deserialize
    ).toPromise();
  }

  public modifyFeedback(
    immoTaskChanges: ImmoIPImmoTaskChangesObject
  ): Promise<void> {
    const requestBody: ModifyFeedbackRequestBody = {
      id: immoTaskChanges.id,
      executionFeedback: immoTaskChanges.executionFeedback,
    };
    return this.post(
      '/modifyFeedback',
      requestBody,
      DeserializeVoid
    ).toPromise();
  }
}

interface SubmitRequestBody {
  id: number;
  executionFeedback: string;
  executed: boolean;
  executedDate: Date;
}

interface SubmitResponse {
  immoTaskId: number;
  executedRegistration: LoggedAction;
}

interface ModifyFeedbackRequestBody {
  id: number;
  executionFeedback: string;
}
